import { Context } from "../../index";
import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { Button, Dropdown } from "react-bootstrap";

const TypeAssFiltrProd = observer(() => {
    const { book } = useContext(Context);
    const [hoveredItemId, setHoveredItemId] = useState(null);

    const isMobile = window.innerWidth < 480; // ✅ или вынести useMediaQuery

    // ✅ Тоггл выбора
    const handleAssTypeChange = (assType) => {
        const currentId = book.selectedAssType?.id ?? null;
        const next = currentId === assType.id ? "" : assType;
        book.setSelectedAssType(next);
    };

    // ✅ Список типов
    const types = book.asstypes
        .slice(22, 27)
        .filter((g) => ![10].includes(g.id));

    // ✅ Мобильная версия — Dropdown
    if (isMobile) {
        return (
            <Dropdown className="mb-0">
                <Dropdown.Toggle variant="success" size="sm">
                    {book.selectedAssType?.ass_type || "Filter by Type"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {types.map((g) => (
                        <Dropdown.Item
                            key={g.id}
                            active={book.selectedAssType?.id === g.id}
                            onClick={() => handleAssTypeChange(g)}
                        >
                            {g.ass_type}
                        </Dropdown.Item>
                    ))}

                    {book.selectedAssType && (
                        <>
                            <Dropdown.Divider />
                            <Dropdown.Item
                                onClick={() => book.setSelectedAssType("")}
                                className="text-danger fw-semibold"
                            >
                                Clear selection
                            </Dropdown.Item>
                        </>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    // ✅ Десктоп — кнопки
    return (
        <div className="d-flex flex-wrap justify-content-start">
            {types.map((g) => {
                const isActive = book.selectedAssType?.id === g.id;

                return (
                    <Button
                        key={g.id}
                        variant={
                            hoveredItemId === g.id || isActive
                                ? "success"
                                : "outline-success"
                        }
                        className="mx-1 d-flex btn-sm mb-2 align-items-center justify-content-start"
                        style={{
                            transition: "transform 0.2s",
                            transform:
                                hoveredItemId === g.id ? "scale(1.05)" : "scale(1)",
                        }}
                        onMouseEnter={() => setHoveredItemId(g.id)}
                        onMouseLeave={() => setHoveredItemId(null)}
                        onClick={() => handleAssTypeChange(g)}
                        active={isActive}
                        aria-pressed={isActive}
                    >
                        {g.ass_type}
                    </Button>
                );
            })}
        </div>
    );
});

export default TypeAssFiltrProd;
